import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Sparkles } from 'lucide-react';
const UPSELL_BOOK_IMAGE = 'https://cdn.magicpatterns.com/uploads/4rbqrvsPZa6QwAoQqopq2W/ChatGPT_Image_16_ene_2026,_12_44_03.png';
const UPSELL_CHECKOUT_URL = 'https://checkout.keybookpro.com/cart/42836634107967:1';
export function UpsellSection() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 0.2
  }} className="mt-12 max-w-4xl mx-auto" data-id="element-73">
      <div className="bg-gradient-to-br from-pink-50 via-white to-blue-50 rounded-3xl p-8 md:p-12 border-2 border-pink-100 shadow-lg" data-id="element-74">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-75">
          <div className="inline-flex items-center gap-2 bg-pink-100 text-pink-700 px-4 py-2 rounded-full text-sm font-semibold mb-4" data-id="element-76">
            <Sparkles className="w-4 h-4" data-id="element-77" />
            Complemento Emocional Ideal
          </div>
          <h3 className="text-2xl md:text-3xl font-bold text-gray-700 mb-3" data-id="element-78">
            🌸 Sumá un libro clave para tu bienestar emocional
          </h3>
        </div>

        {/* Content Grid */}
        <div className="grid md:grid-cols-2 gap-8 items-center mb-8" data-id="element-79">
          {/* Book Image */}
          <div className="flex justify-center" data-id="element-80">
            <img src={UPSELL_BOOK_IMAGE} alt="Dejá de Exigirte Sin Culpa" className="w-full max-w-xs rounded-lg shadow-xl hover:scale-105 transition-transform duration-300" data-id="element-81" />
          </div>

          {/* Description */}
          <div className="space-y-4" data-id="element-82">
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-83">
              <span className="font-semibold text-gray-700" data-id="element-84">
                Dejá de Exigirte Sin Culpa
              </span>{' '}
              es el complemento emocional ideal cuando el estrés baja, pero la
              culpa sigue.
            </p>

            <div className="space-y-3" data-id="element-85">
              <p className="font-semibold text-gray-700 mb-3" data-id="element-86">
                Este libro te ayuda a:
              </p>
              {['Soltar la autoexigencia constante', 'Trabajar la culpa invisible al cuidarte', 'Priorizarte sin sentir que fallás', 'Ser más amable con vos misma como mujer, madre o pareja'].map((benefit, i) => <div key={i} className="flex items-start gap-3" data-id="element-87">
                  <Heart className="w-5 h-5 text-pink-500 flex-shrink-0 mt-0.5" data-id="element-88" />
                  <span className="text-gray-600" data-id="element-89">{benefit}</span>
                </div>)}
            </div>

            <div className="bg-white/80 p-4 rounded-xl border border-pink-100 mt-6" data-id="element-90">
              <p className="text-center text-gray-600 italic" data-id="element-91">
                No se trata de hacer más. Se trata de exigirte menos y
                respetarte más 🤍
              </p>
            </div>
          </div>
        </div>

        {/* Pricing */}
        <div className="text-center mb-6" data-id="element-92">
          <div className="mb-4" data-id="element-93">
            <span className="text-gray-400 line-through text-xl mr-3" data-id="element-94">
              Antes $59.900 ARS
            </span>
            <span className="text-4xl md:text-5xl font-bold text-pink-600" data-id="element-95">
              $26.990 ARS
            </span>
          </div>
          <p className="text-sm text-gray-500 mb-6" data-id="element-96">
            Precio especial por tiempo limitado
          </p>

          <a href={UPSELL_CHECKOUT_URL} className="inline-block bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white text-lg md:text-xl font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-97">
            Sí, quiero sumar este libro con descuento
          </a>
        </div>

        {/* Pack Summary */}
        <div className="bg-white/90 rounded-2xl p-6 border border-gray-200" data-id="element-98">
          <h4 className="font-bold text-gray-700 text-center mb-4 text-lg" data-id="element-99">
            🎁 Pack completo de bienestar
          </h4>
          <div className="space-y-2 text-gray-600" data-id="element-100">
            <div className="flex items-center gap-3" data-id="element-101">
              <div className="w-2 h-2 rounded-full bg-teal-500" data-id="element-102" />
              <span data-id="element-103">
                📘 Estrés en Pausa + 5 bonos + 3 audios de relajación guiada
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-104">
              <div className="w-2 h-2 rounded-full bg-pink-500" data-id="element-105" />
              <span data-id="element-106">📘 Dejá de Exigirte Sin Culpa (libro exclusivo)</span>
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}